import { render, staticRenderFns } from "./FastbotList.vue?vue&type=template&id=595a0961&scoped=true"
import script from "./FastbotList.vue?vue&type=script&lang=ts"
export * from "./FastbotList.vue?vue&type=script&lang=ts"
import style0 from "./FastbotList.vue?vue&type=style&index=0&id=595a0961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595a0961",
  null
  
)

export default component.exports